// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dotbottom[data-v-727756f2] {\n  border-bottom: 2px dotted black;\n}\n", ""]);
// Exports
module.exports = exports;
